import localforage from 'localforage'
import { isEmpty } from 'lodash'
import { setHttpToken, setHttpBaseUrl } from '../../../helpers'

export const login = ({ commit, dispatch }, { payload, context }) => {
    return window.axios.post(process.env.VUE_APP_SSO_API_URL + 'api/signin', payload).then((response) => {

        //set User details
        if(response.data.success && payload.keepMeLoggedIn){
            commit('setUser', {
                "email" : payload.email,
                "password" : payload.password,
                "keepMeLoggedIn": payload.keepMeLoggedIn,
                "sso_data":response.data.user,
                "profilePicUrl":response.data.profilePicUrl.profile_pic
            });
        }else{
            commit('setUser', {
                "email" : payload.email,
                "password" : payload.password,
                "keepMeLoggedIn": payload.keepMeLoggedIn,
                "sso_data":response.data.user,
                "profilePicUrl":response.data.profilePicUrl.profile_pic
            });
        }

        // Setting up auth token ad fetching user data
        dispatch('setToken', response.data.token).then(() => {
            const ualPayload = {
                "email" : payload.email,
                "token": response.data.token
            }
        })
        return response.data;
    }).catch((error) => {
        let message = error.response.data.message
        dispatch('errorHandler',error.response.status);
        if (isEmpty(message)) {
            message = "Something Went Wrong"
        }
        commit('SET_ALERT', 'warning', { root: true })
        commit('SET_ALERT_MESSAGE', message, { root: true })
        context.isbeingLoggedIn = false
        if (!isEmpty(error.response.data.errors)) {
            context.errors = error.response.data.errors
        }
        return false
    })
}

export const loginRESTApi = ({ commit, dispatch },{payload, context}) => {

    return window.axios.post(process.env.VUE_APP_SMART_ART_API_URL + 'api/sign-in',payload).then((response) => {
        try{
            if(response.data.success){
                localStorage.setItem('data', JSON.stringify(response.data.user));
                // Showing  success message
                commit('SET_ALERT', 'success', { root: true })
                commit('SET_ALERT_MESSAGE', response.data.message, { root: true })
            }else{
                commit('setUser', {
                    "email" : payload.email,
                    "password" : '',
                    "keepMeLoggedIn": payload.keepMeLoggedIn,
                    'data':'',
                    "profilePicUrl":''
                });
            }

            dispatch('fetchUser');
        }catch(error){
            console.log('Rest Login Api error',error);
            commit('setUser', {
                "email" : payload.email,
                "password" : '',
                "keepMeLoggedIn": payload.keepMeLoggedIn,
                "data":'',
                "profilePicUrl":''
            });
        }

        return response.data;
    }).catch((error) => {
        dispatch('errorHandler',error.response.status);
        commit('SET_ALERT', 'warning', { root: true })
        commit('SET_ALERT_MESSAGE', 'Something went wrong', { root: true })
        context.errors = error.response.data.errors
        return false
    });
}

export const logout = ({ dispatch },payload) => {
    setHttpBaseUrl(null)
    return window.axios.post(process.env.VUE_APP_SSO_API_URL + 'api/logout').then((response) => {
        dispatch('clearAuth').then(()=>{
            dispatch('logoutUnautorizedUser','');
        })
    }).catch(e => {
        dispatch('errorHandler',e.response.status);
        console.log('logout error response:', e);
        return e;
    });
}

export const logoutUnautorizedUser = (context,payload) => {
    let user = {
        "email" : localStorage.getItem('email'),
        "password" : localStorage.getItem('password'),
        "keepMeLoggedIn": JSON.parse(localStorage.getItem('keepMeLoggedIn')),
        "locale" : localStorage.getItem('localforage/smartartadmin/locale')
    }
    try{
        localStorage.clear();
        localStorage.setItem("localforage/smartartadmin/locale", user.locale);
        if(user && user.keepMeLoggedIn === true) {
            localStorage.setItem("email", user.email);
            localStorage.setItem("password", user.password);
            localStorage.setItem("keepMeLoggedIn", JSON.stringify(user.keepMeLoggedIn));
        }
    }catch($e){
        console.log($e);
    }
}

export const setToken = ({ commit, dispatch }, token) => {
    if (isEmpty(token)) {
        return dispatch('checkTokenExists').then((token) => {
            setHttpToken(token)
            setHttpBaseUrlAfterLogin(token)
        })
    }
    commit('setToken', token)
    setHttpToken(token)
}

export const fetchBellNotifications = ({ commit, dispatch }) => {
    return window.axios.get(process.env.VUE_APP_SMART_ART_API_URL + 'api/bell/notify/records').then((response) => {
        commit('setBellNotifications', response.data)
    })
}

export const markNotificationsAsSeen = ({ commit, dispatch }) => {
    return window.axios.post(process.env.VUE_APP_SMART_ART_API_URL + 'api/bell/notify/mark-seen').then((response) => {
        commit('setBellNotifications', {count: 0, data: []})
    })
}

export const fetchUser = ({ commit, dispatch }) => {

    const email = localStorage.getItem('email');
    return window.axios.get(process.env.VUE_APP_SMART_ART_API_URL + 'api/users/profile-details/'+email).then((response) => {
        commit('setAuthenticated', true);

        let userData = response.data
        if (userData.details.change_password_at_login) {
            commit('showChangePasswordModel', true, { root: true })
        }
        commit('setUserData', response.data)
        // commit('HANDLE_MAIN_HEADER_BASED_ON_AUTH', null, { root: true })
        //dispatch('fetchBellNotifications')
        return response.data;
    }).catch((error) => {
        dispatch('errorHandler',error.response.status);
        return false
    })
}

export const checkTokenExists = ({ commit, dispatch }, token) => {
    return localforage.getItem('authtoken').then((token) => {
        if (isEmpty(token)) {
            return Promise.reject('NO_STORAGE_TOKEN')
        }

        return Promise.resolve(token)
    }).catch((error) => {
        dispatch('errorHandler',error.response.status);
        return false
    })
}

export const checkIfRoleSelected = ({commit}, context) => {
    commit('CHECK_ROLE_SELECTION', context)
}

export const clearAuth = ({commit}) => {
    commit('setAuthenticated', false)
    commit('setUserData', null)
    commit('setToken', null)
    setHttpToken(null)
    setHttpBaseUrl(null)
    // commit('HANDLE_MAIN_HEADER_BASED_ON_AUTH', null, { root: true })
}

export const setHttpBaseUrlAfterLogin = (token) => {
    return localforage.getItem('authtoken').then((token) => {
        if (isEmpty(token)) {
            return Promise.reject('NO_STORAGE_TOKEN')
        }
        setHttpBaseUrl(token)
        return Promise.resolve(token)
    })
}

export const saveChangePassword = ({ commit, dispatch }, { payload, context }) => {
    const frmData = {
        old_password: payload.oldPassword,
        password: payload.newPassword,
        confirm_password: payload.reNewPassword,
        user_id: payload.user_id
    };
    return window.axios.post(process.env.VUE_APP_SSO_API_URL + 'api/change-password', frmData).then((response) => {
        if(response){
            commit('SET_ALERT', 'success', { root: true })
            commit('SET_ALERT_MESSAGE', response.data.message, { root: true })
            if(response.data.success){
                const activityLog = window.axios.post(process.env.VUE_APP_SMART_ART_API_URL + 'api/activity-log-change-password', frmData).then((res) => {
                    if(res.data.success){
                        
                    }
                }).catch((error) => {
                    commit('SET_ALERT', 'warning', { root: true })
                    commit('SET_ALERT_MESSAGE', 'Something went wrong', { root: true })
                    context.errors = error.response.data.errors
                    return false;
                })
            }
            return response;
        }
    }).catch((error) => {
        console.log(error);
        if(error.response.status == 422){
            let laraErrors = error.response.data.errors; // this should be errors.
            commit('SET_ALERT', 'warning', { root: true })
            commit('SET_ALERT_MESSAGE', laraErrors.password[0], { root: true })
        } else if(error.response.status == 400){
            commit('SET_ALERT', 'warning', { root: true })
            commit('SET_ALERT_MESSAGE', error.response.data.message, { root: true })
        } else {
            dispatch('errorHandler',error.response.status);
            commit('SET_ALERT', 'warning', { root: true })
            commit('SET_ALERT_MESSAGE', 'Something went wrong SSO', { root: true })
            context.errors = error.response.data.errors
            return false;
        }
    })
}

export const forgotpassword = ({ commit, dispatch }, { payload, context }) => {
    return window.axios.post(process.env.VUE_APP_SSO_API_URL + 'api/password/forgot-password', payload).then((response) => {
        if(response.data.success){
            let token = response.data.token;
            let email = response.data.email;
            const payloadForgotPassword = {
                token:token,
                email:email,
                fromAdmin: true,
                type : "super-admin"
            }
            return window.axios.post(process.env.VUE_APP_SMART_ART_API_URL + 'api/forgot-password', payloadForgotPassword).then((response) => {
                if(response.data.success == true){
                    commit('SET_ALERT', 'success', { root: true })
                    commit('SET_ALERT_MESSAGE', response.data.message, { root: true })
                    return response;
                } else {
                    commit('SET_ALERT', 'warning', { root: true })
                    commit('SET_ALERT_MESSAGE', response.data.message, { root: true })
                    return response;
                }
            }).catch((error) => {
                commit('SET_ALERT', 'warning', { root: true })
                commit('SET_ALERT_MESSAGE', 'Something went wrong', { root: true })
                context.errors = error.response.data.errors
                return false;
            })
        }
        return response.data.success
    }).catch((error) => {
        dispatch('errorHandler',error.response.status);
        commit('SET_ALERT', 'warning', { root: true })
        commit('SET_ALERT_MESSAGE', 'User Not found', { root: true })
        context.errors = error.response.data.errors
        return false
    })
}

export const resetpassword = ({ commit, dispatch }, { payload, context }) => {
    return window.axios.post(process.env.VUE_APP_SSO_API_URL + 'api/password/reset', payload).then((response) => {
        // Showing  success message
        commit('SET_ALERT', 'success', { root: true })
        commit('SET_ALERT_MESSAGE', response.data.message, { root: true })
        if(response.data.success){
            const activityLog = window.axios.post(process.env.VUE_APP_SMART_ART_API_URL + 'api/activity-log-reset-password', payload).then((res) => {
                if(res.data.success){

                }
            }).catch((error) => {
                commit('SET_ALERT', 'warning', { root: true })
                commit('SET_ALERT_MESSAGE', 'Something went wrong', { root: true })
                context.errors = error.response.data.errors
                return false;
            })
        }
        return response;
    }).catch((error) => {
        console.log(error);
        if(error.response.status == 400){
            commit('SET_ALERT', 'warning', { root: true })
            commit('SET_ALERT_MESSAGE', error.response.data.message, { root: true })
        } else if(error.response.status == 422){
            commit('SET_ALERT', 'warning', { root: true })
            commit('SET_ALERT_MESSAGE', error.response.data.password[0], { root: true })
            context.errors = error.response.data.errors
            return false;
        }else {
            dispatch('errorHandler',error.response.status);
            commit('SET_ALERT', 'warning', { root: true })
            commit('SET_ALERT_MESSAGE', 'Something went wrong SSO', { root: true })
            context.errors = error.response.data.errors
            return false;
        }
    })
}

export const getUserAgreementSubscriptionData = ({ commit, dispatch },{payload, context}) => {
    return window.axios.post(process.env.VUE_APP_SMART_ART_API_URL + 'api/getUserAgreementSubscriptionData',payload,{
        headers: {
            //'Authorization': 'Bearer ' + localStorage.getItem("localforage/smartartadmin/authtoken")
        }
        }).then((res) => {
            return res.data;
        }).catch((error) => {
            dispatch('errorHandler',error.response.status);
           return false;
        });
}

export const errorHandler = ({dispatch },payload) => {
    try{
        if(payload === 401){
            dispatch('logoutUnautorizedUser','');
            window.location.href = window.location.origin + "/";
        }
    }catch($e){
        console.log($e);
    }
}

export const getUserCrowdfundingData = ({ commit, dispatch}, {payload, context}) => {
    return window.axios.post(process.env.VUE_APP_SMART_ART_API_URL + 'api/get-user-crowdfunding-amount',payload).then((response) => {
        return response.data;
    }).catch((error) => {
        dispatch('errorHandler',error.response.status);
        //commit("SET_ALERT", "warning", { root: true });
        //commit("SET_ALERT_MESSAGE",  error.response.data.message, { root: true });
        return false;
    });   
};

export const retriveStripData = ({ commit,dispatch }, {payload}) => {
    return window.axios.get(process.env.VUE_APP_SMART_ART_API_URL+'api/retrive-stripe-data?session_id='+payload+'&type=superadmin').then((response) => {
        return response.data;
    }).catch((error) => {
        dispatch('errorHandler',error.response.status);
       commit("SET_ALERT", "warning", { root: true });
       commit("SET_ALERT_MESSAGE", "Something went wrong " + error, { root: true });
       return false;
    });
};

export const stripeSuccess = ({ commit, dispatch }, {payload}) => {
   return window.axios.post(process.env.VUE_APP_SMART_ART_API_URL+'api/stripe-crowdfund-payment-success',payload).then((response) => {
       return response.data;
    }).catch((error) => {
        dispatch('errorHandler',error.response.status);
       commit("SET_ALERT", "warning", { root: true });
       commit("SET_ALERT_MESSAGE", "Something went wrong " + error, { root: true });
       return false;
    });       
};

export const payToSeller = ({ commit, dispatch }, { payload, context }) => {
    return window.axios.post(process.env.VUE_APP_SMART_ART_API_URL + 'api/pay-to-seller', payload).then((res) => {
        return res;
    }).catch((error) => {
        if(error.response.status == 422){
            let laraErrors = error.response.data.errors; // this should be errors.
            commit('SET_ALERT', 'warning', { root: true })
            commit('SET_ALERT_MESSAGE', laraErrors.email, { root: true })
        } else if(error.response.status == 400){
            commit('SET_ALERT', 'warning', { root: true })
            commit('SET_ALERT_MESSAGE', error.response.data.message, { root: true })
        } else {
            dispatch('errorHandler',error.response.status);
            commit('SET_ALERT', 'warning', { root: true })
            commit('SET_ALERT_MESSAGE', 'Something went wrong SSO', { root: true })
            context.errors = error.response.data.errors
            return false;
        }
    })
}

export const getSettingsClient = ({ commit, dispatch }, { payload, context }) => {
    let query = payload.edit ? '?edit=true' : '';
    return window.axios.get(process.env.VUE_APP_SMART_ART_API_URL + 'api/users/profile-details/' + payload.email + query).then((response) => {
        return response.data.details;
    }).catch((error) => {
        dispatch('errorHandler',error.response.status);
        commit('SET_ALERT', 'warning', { root: true });
        commit('SET_ALERT_MESSAGE', 'Something went wrong', { root: true });
        return false;
    })
}

export const signInUserlogout = ({commit, dispatch},{payload}) =>{
    return window.axios.post(process.env.VUE_APP_SSO_API_URL + 'api/user-sign-in-logout',payload).then((response) => {
        return response.data;
    }).catch((error) => {
        dispatch('errorHandler',error.response.status);
        commit('SET_ALERT', 'warning', { root: true })
        commit('SET_ALERT_MESSAGE', 'Something went wrong', { root: true })
    })
}

export const getSiteSettingsClient = ({ commit, dispatch }, payload) => {
    let query = payload && payload.edit ? '?edit=true' : '';
    return window.axios.get(process.env.VUE_APP_SMART_ART_API_URL + 'api/getSiteSettingsClient' + query).then((response) => {
        return response.data;
    }).catch((error) => {
        dispatch('errorHandler',error.response.status);
        commit("SET_ALERT", "warning", { root: true });
        commit("SET_ALERT_MESSAGE", "Something went wrong getSiteSettingsClient " + error, { root: true });
        return false;
    });
}

export const sendotp = ({ commit, dispatch }, {payload, context}) => {
    let email = '';
    let otp = '';
    return window.axios.post(process.env.VUE_APP_SSO_API_URL + 'api/get-otp',payload).then((response) => {
        if(response.data.success){
            email = response.data.email;
            otp = response.data.otp;
            payload.email = email;
            payload.otp = otp;
            return window.axios.post(process.env.VUE_APP_SMART_ART_API_URL + 'api/send-otp', payload).then((res) => {
                if(res.data.success == true){
                    return res;
                } else {
                    return res;
                }
            }).catch((error) => {
                commit('SET_ALERT', 'warning', { root: true })
                commit('SET_ALERT_MESSAGE', 'Something went wrong', { root: true })
                context.errors = error.response.data.errors
                return false;
            })
        }
    }).catch ((error) => {
        dispatch('errorHandler',error.response.status);
        commit("SET_ALERT", "warning", { root: true });
        commit("SET_ALERT_MESSAGE", "Something went wrong sendotp " + error, { root: true });
    });
}

export const verifyEmail = ({ commit, dispatch }, {payload, context}) => {
    return window.axios.post(process.env.VUE_APP_SSO_API_URL + 'api/verify-email',payload).then((response) => {
        if(response.data.success){
            if (response.data && response.data.success) {
                return response.data.success
            } else if (response.data && response.data.error) {
                console.log("email verify error response on UI");
            }
            return response.data;
        }
        return response.data;
    }).catch ((error) => {
        dispatch('errorHandler',error.response.status);
        commit("SET_ALERT", "warning", { root: true });
        commit("SET_ALERT_MESSAGE", "Something went wrong verifyEmail " + error, { root: true });
    });    
}

export const verifiedEmail = ({ commit, dispatch }, {payload, context}) => {
    return window.axios.post(process.env.VUE_APP_SSO_API_URL + 'api/verified-email',payload).then((response) => {
        console.log("verifiedEmail",response);
        if(response.data){
            return response.data.success;
        }
    }).catch ((error) => {
        dispatch('errorHandler',error.response.status);
        commit("SET_ALERT", "warning", { root: true });
        commit("SET_ALERT_MESSAGE", "Something went wrong verifiedEmail " + error, { root: true });
    });
}